<template>
  <modal-container
    ref="modal"
    width="90%"
    maxWidth="700px"
  >
    <template slot="modal-content">
      <div>
        <h3>Conferma operazione</h3>

        <p>Questa operazione è irreversibile. Sei sicuro di voler cancellare il tuo account?</p>

        <div class="flex align-items-center">
          <span class="flex-right font-weight-bold" v-if="this.alertDelete">Cancellazione in corso</span>
          <div class="flex-right">
            <CTA size="small" color="danger" isWithLoader :loading="loading" content="Sì, cancella" @click="deleteAbo()"></CTA>
          </div>
          <div>
            <button class="btn" @click="close()">Chiudi</button>
          </div>
        </div>
      </div>

    </template>
  </modal-container>
</template>

<script>
import { SubscriptionApi } from '../../api/SubscriptionApi'

export default {

  data() {
    return {
      loading: false,
      alertDelete: false
    }
  },

  props: {
    user: {
      type: Object,
      default () {
        return null
      }
    }
  },

  methods: {
    open () {
      this.$refs.modal.open()
    },

    close () {
      this.$refs.modal.close()
    },

    deleteAbo () {
      this.alertDelete = true
      this.loading = true
      var sm = new SubscriptionApi()
      sm.delete(this.user.subscription).then(response => {
        window.location.reload()
      }).catch(error => {
        this.alertDelete = false
        this.loading = false
      })
    }
  }
}

</script>

<style scoped>

  .modal-inner {
    max-width: 700px;
  }
</style>
